import { render, staticRenderFns } from "./activityForm.vue?vue&type=template&id=55e67de1"
import script from "./activityForm.vue?vue&type=script&lang=js"
export * from "./activityForm.vue?vue&type=script&lang=js"
import style0 from "./activityForm.vue?vue&type=style&index=0&id=55e67de1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports